{
  "version": 1,
  "asset_id": "0d388632-f7aa-4736-b7c6-d40ab7309a65",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/0d388632-f7aa-4736-b7c6-d40ab7309a65/destination-roofing-owner-dump-trailer-crystal-river-fl-480w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/0d388632-f7aa-4736-b7c6-d40ab7309a65/destination-roofing-owner-dump-trailer-crystal-river-fl-480w.webp",
  "original_filename": "destination-roofing-owner-dump-trailer-crystal-river-fl-480w.webp",
  "size": 21022,
  "content_type": "image/webp",
  "created_at": "2026-07-16T20:37:38Z"
}
